import { render, staticRenderFns } from "./PoljeUnosaTekst.vue?vue&type=template&id=4208e29b&scoped=true"
import script from "./PoljeUnosaTekst.vue?vue&type=script&lang=js"
export * from "./PoljeUnosaTekst.vue?vue&type=script&lang=js"
import style0 from "./PoljeUnosaTekst.vue?vue&type=style&index=0&id=4208e29b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4208e29b",
  null
  
)

export default component.exports